<template>
<nav class="footer bg-dark">
  <div class="container text-center py-3">
    <div class="pb-3">
      <b-link to="/home" class="footer-link pt-3">الرئيسية</b-link>
      <b-link to="/about" class="footer-link pt-3 ml-4"> عن المستشفى</b-link>
      <b-link to="/news" class="footer-link pt-3 ml-4"> الاخبار و المقالات</b-link>
      <b-link to="/timetables" class="footer-link pt-3 ml-4">مواعيد العيادات التخصصيه</b-link>
      <b-link to="/contact" class="footer-link pt-3 ml-4">لتواصل معنا</b-link>
    </div>

    <hr class="m-0 mb-5">

    <!-- <div class="col-md-9 col-lg-7 col-xl-6 px-0 my-4 mx-auto">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
      vulputate commodo justo, a malesuada magna interdum sodales.
      Vestibulum bibendum fermentum tortor, eu blandit orci porta quis.
    </div> -->

    <div class="pb-3">
      <a href="#" class="footer-text font-weight-bolder">مستشفى الطارق</a> ©
      <span class="footer-text">تصميم و تطوير</span>
        <a class="footer-text text-info" href="http://www.digitallibya.com">ديجيتال ليبيا</a>
    </div>
  </div>
</nav>
</template>

<script>
export default {
  name: 'app-layout-footer',

  methods: {
    getLayoutFooterBg () {
      return `bg-${this.layoutFooterBg}`
    }
  }
}
</script>
